module.exports = __webpack_public_path__ + "img/logo-no-text.3603cd23.svg";